import React from 'react'
import {Field,ErrorMessage} from 'formik'
import { TextError } from '../TextError'

const Textarea = (props) => {
    const {label,name,...rest}=props;

  return (
<>
    <label htmlFor={name}>{label}</label>
    <Field as="textarea" id={name} name={name} {...rest} className="form-control" />
    <ErrorMessage name={name} component={TextError} />
 </>
  )
}

export default Textarea